import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    NestedKeyOf,
} from 'app/types/utils.types'

import {
    CQuoteContactDetails,
} from '../../CQuoteInformationContext'

const getFields = (
    generatePdfDisabled: boolean,
): DTOCardFormField<NestedKeyOf<CQuoteContactDetails>>[] => {
    return [{
        id: 'contactDetails',
        title: 'Contact Details',
        className: 'contactDetails',
        fields: [
            {
                id: 'contactDetails-column1',
                fields: [{
                    name: 'skyCellContact',
                    componentName: 'UserObjectSelector',
                    required: true,
                    labelKey: 'AccountQuotes.skycellContact',
                }],
            },
            {
                id: 'contactDetails-column2',
                fields: [{
                    name: 'quotedFor',
                    componentName: 'ContactObjectSelector',
                    required: true,
                    labelKey: 'AccountQuotes.quotedFor',
                }],
            },
            {
                id: 'contactDetails-column3',
                className: 'generatePdfCheckbox',
                fields: [{
                    name: 'generatePdf',
                    componentName: 'Checkbox',
                    required: true,
                    disabled: generatePdfDisabled,
                    labelKey: 'AccountQuotes.generatePdf',
                }],
            },
        ],
    }]
}

export default getFields
